module.exports = __webpack_public_path__ + "img/triangulo-naranja-2.35f284e1.svg";